function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.89538 13.8394V11.5797C4.89537 11.007 5.36102 10.5418 5.93779 10.5382H8.05561C8.63496 10.5382 9.10462 11.0045 9.10462 11.5797V13.8329C9.10461 14.3296 9.50823 14.7332 10.0085 14.7368H11.4533C12.1282 14.7386 12.7759 14.4736 13.2537 14.0005C13.7315 13.5274 14 12.885 14 12.215V5.79589C14 5.25471 13.7584 4.74137 13.3402 4.39416L8.43167 0.496829C7.57364 -0.184857 6.34817 -0.162836 5.51555 0.54923L0.712535 4.39416C0.274651 4.73113 0.0129333 5.24599 0 5.79589V12.2085C0 13.6048 1.14018 14.7368 2.54665 14.7368H3.95853C4.19939 14.7386 4.43099 14.6448 4.60193 14.4763C4.77286 14.3078 4.869 14.0786 4.86899 13.8394H4.89538Z"
});

function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b2927f6f.svg";
export { ForwardRef as ReactComponent };